import 'core-js'

/* Dependencies
 ---------------------------------------------------------- */
import { Application } from 'wrapper6'

/* Services
 ---------------------------------------------------------- */

/* Register services
 ---------------------------------------------------------- */

/* Modules
 ---------------------------------------------------------- */
import Polyfills from './utils/_polyfills'
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import NavigationSearch from './modules/_navigation-search'
import CoverSlider from './modules/_cover-slider'
import PostsSlider from './modules/_posts-slider'
import LazyLoad from './modules/_lazy-load'
import VideoModal from './modules/_video-modal'
import Tabs from './modules/_tabs'
import SliderWithLightbox from './modules/_slider-with-lightbox'
import ReadMore from './modules/_read-more'
import TechnicalData from './modules/_technical-data'
import UnderTabs from './modules/_under-tabs'
import Sticky from './modules/_sticky'
import ArchiveProduct from './modules/_archive-product'
import Accordion from './modules/_accordion'
import SmoothScroll from './modules/_smooth-scroll'
import Filters from './modules/_filters'
import Employees from './modules/_employees'
import MendelayModal from './modules/_mendelay-modal'
import Modal from './modules/_modal'
import MendelayArchive from './modules/_mendelay-archive'
import LanguageSelector from './modules/_language-selector'
import ScrollToTop from './modules/_scroll-to-top'
import MegaMenu from './modules/_mega-menu'

/* Vendor
 ---------------------------------------------------------- */

/* Setup
 ---------------------------------------------------------- */
const app = window.app = new Application(window.options || {})

/* Register modules
 ---------------------------------------------------------- */
app.use(Polyfills)
app.use(Navigation)
app.use(ObjectFit)
app.use(Print)
app.use(NavigationSearch)
app.use(CoverSlider)
app.use(PostsSlider)
app.use(LazyLoad)
app.use(VideoModal)
app.use(SliderWithLightbox)
app.use(Tabs)
app.use(ReadMore)
app.use(TechnicalData)
app.use(UnderTabs)
app.use(Sticky)
app.use(ArchiveProduct)
app.use(Accordion)
app.use(SmoothScroll)
app.use(Filters)
app.use(Employees)
app.use(Modal)
app.use(MendelayModal)
app.use(MendelayArchive)
app.use(LanguageSelector)
app.use(ScrollToTop)
app.use(MegaMenu)

require('./app')
